import React, {useEffect, useState, useRef, useContext} from "react";
import AmChartXY from '../../../components/AmChartXY';
import SelectionTool from '../../../components/SelectionTool';
import {SERIES_TYPE_LINE} from "../../../constants/charts";
import {SERIES_TYPE_COLUMN} from "../../../constants/charts";
import {CATEGORY_TYPE_CATEGORY} from "../../../constants/charts";
import {TRUE} from "../../../constants/general-constants";

export default function RealEstateTimeline(){

	const [chartData, setChartData] = useState([]);
	const [loaded, setLoaded] = useState("false");

	
	useEffect(() => {
		loadChartData();
		setLoaded("true");
	}, [loaded]);
	
	const thisContainer = {
		display:"flex",
		paddingLeft:"20px",
		paddingRight:"20px",
		paddingBottom:"20px",
		width:"calc(100% - 90px)",
		flexDirection:"column",
		alignItems:"center",
		justifyContent:"space-around",
		backgroundColor:"white",
		borderRadius:"6px",
		marginLeft:"20px",
		marginTop:"20px"
	};
	
	const loadChartData = () => {
		let tempChartData = [];
		for(let i=0; i<160; i++){
			let leases = Math.round(Math.random()*200) + 1200;
			let subleases = Math.round(Math.random()*200) + 1200;
			
			tempChartData.push({
					label:"Period " + i, 
					leasenumber:leases, 
					leasevalue:leases*1000,
					subleasenumber:subleases, 
					subleasevalue:subleases*1000
			});	
		}
		
		setChartData(tempChartData);
	};
	
	const chartAdditionalAxes = [
		{opposite:"true", title:"Total Area SqM"}
	];
	
	const chartProps = {
    fontSize:"14px",
    showScrollbar:true,
    showScrollbarY:false,
    showCursor:true,
    showLegend:true,
    marginLeft:0
	};
	
	const optionValues = [
		{id:"1", name:"Area"},
		{id:"2", name:"Cost"},
		{id:"3", name:"Capacity"}
	];
	
	const chartGraphs = [
		{
			name:"No. Leases",
			seriesType:SERIES_TYPE_COLUMN,
			yKey:"leasenumber",
			color:"#F34236",
			columnWidth:"70"
		},
		{
			name:"Leased Area",
			seriesType:SERIES_TYPE_LINE,
			yKey:"leasevalue",
			color:"#E81E63",
			bullets:true,
			additionalAxisAddress:1
		},
		{
			name:"No. Sub Leases",
			seriesType:SERIES_TYPE_COLUMN,
			yKey:"subleasenumber",
			color:"#3F51B5",
			columnWidth:"70"
		},
		{
			name:"Sublet Area",
			seriesType:SERIES_TYPE_LINE,
			yKey:"subleasevalue",
			color:"#2096F3",
			bullets:true,
			additionalAxisAddress:1
		}
	];
	
		
	return (
		<div style={thisContainer}>
		
			<AmChartXY
					chartId="realestatehomelinechart"
					width="100%"
					height="500px"
					props={chartProps}
					chartData={chartData}
					chartGraphs={chartGraphs}
					categoryType={CATEGORY_TYPE_CATEGORY}
					categoryKey="label"
					labelsRotate="true"
					xAxisTitle="Time Line"
					yAxisTitle="Total Number"
					additionalAxes={chartAdditionalAxes}
				>
				</AmChartXY>
				<SelectionTool
				title="Show"
				value="Area"
				values={optionValues}
				dataLoad={loadChartData}
			>
			</SelectionTool>
		</div>
		
	);
}